import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

type TriggeredProps = {
  use: Function[];
  onActivate: Function;
  children?: Function | ReactNode;
};

export function Triggered({
  children,
  onActivate = () => {},
  use: triggers
}: TriggeredProps) {
  const [activatedTrigger, setActivatedTrigger] = useState(undefined);
  const [valueActivatedTrigger, setValueActivatedTrigger] = useState(undefined);

  useEffect(() => {
    if (activatedTrigger !== undefined || triggers.length === 0) {
      return undefined;
    }

    const triggersCleanups = triggers.map((registrationFn) => {
      if (typeof registrationFn !== 'function') {
        throw new Error('Trigger must be a function');
      }

      return registrationFn(setActivatedTrigger, setValueActivatedTrigger);
    });

    return () => {
      triggersCleanups.forEach((cleanupFn) => {
        if (typeof cleanupFn === 'function') {
          cleanupFn();
        }
      });
    };
  }, [triggers, activatedTrigger]);

  useEffect(() => {
    if (activatedTrigger !== undefined) {
      onActivate(activatedTrigger, valueActivatedTrigger);
    }
  }, [activatedTrigger, valueActivatedTrigger]);

  if (typeof children === 'function') {
    return children();
  }

  return children;
}
